export default "__VITE_ASSET__Cghlrpmf__"